<app-breadcrumbs></app-breadcrumbs>
<div class="store-number-toolbar">
  <div [cfaLoading]="isLoading">
    <button mat-raised-button (click)="getWifiHealth()" color="primary" id="store-number-search-button">
      <mat-icon>search</mat-icon>
    </button>
    <mat-form-field id="store-number-search-field" appearance="outline">
      <mat-label>Store Number</mat-label>
      <input matInput maxlength="5" minlength="5" (keydown.enter)="getWifiHealth()" [(ngModel)]="storeNumber" autofocus/>
    </mat-form-field>
  </div>
  <app-health-nav [storeNumber]="storeNumber"></app-health-nav>
</div>
<div class="main-card-wrapper">
  @if (mists.length > 0) {
    <div class="zone">
      <div class="zone-header">
        <span class="status-dot status-{{getApSeverity()}}"></span>
        <h3 class="zone-title">Access Points</h3>
        <span class="device-count">{{mists.length}}</span>
        <span class="health-chip" [class.healthy]="isAllApsHealthy()" [class.unhealthy]="!isAllApsHealthy()">
          {{getMistHealthSummary()}}
        </span>
        <button mat-button class="zone-action" (click)="allApsExpanded ? collapseAllAps() : expandAllAps()">
          <mat-icon>{{allApsExpanded ? 'unfold_less' : 'unfold_more'}}</mat-icon>
          {{allApsExpanded ? 'Collapse' : 'Expand'}}
        </button>
      </div>
      <div class="ap-grid wifi-ap-grid">
        @for (mist of mists; track mist; let i = $index) {
          <div class="ap-card" [class.is-online]="mist.status == 'connected'"
            [class.is-offline]="mist.status != 'connected'">
            <button type="button" class="ap-card-head" (click)="toggleAp(i)">
              <span class="status-dot" [class.status-green]="mist.status == 'connected'"
                [class.status-red]="mist.status != 'connected'"></span>
              <span class="ap-name">{{mist.name || 'Access Point'}}</span>
              <span class="ap-model">{{mist.num_clients}} clients</span>
              <mat-icon class="ap-expand-icon">{{expandedAps[i] ? 'expand_less' : 'expand_more'}}</mat-icon>
            </button>
            @if (expandedAps[i]) {
              <div class="ap-details">
                <p><b>Status:</b> {{mist.status == 'connected' ? 'Connected' : 'Disconnected'}}</p>
                <p><b>IP Address:</b> {{mist.ip}}</p>
                <p><b>HW Rev:</b> {{mist.hw_rev || 'Unknown'}}</p>
                <p><b>CPU Usage:</b> {{mist.cpu_util}}%</p>
                <p><b>CPU Temp:</b> <span [ngStyle]="{'color': getColorCpuTemp(mist.env_stat.cpu_temp)}">{{mist.env_stat.cpu_temp}}°C</span></p>
                <p><b>Total Memory Kb:</b> {{mist.mem_total_kb}}</p>
                <p><b>Memory Used Kb:</b> {{mist.mem_used_kb}}</p>
                <p><b>Active Clients:</b> {{mist.num_clients}}</p>
                @for (radio_stat of mist.radio_stat | keyvalue; track radio_stat) {
                  <p><b>{{radio_stat.key}}:</b> Channel {{radio_stat.value.channel}},
                    Utilization {{radio_stat.value.util_all}}%, Power {{radio_stat.value.power}}</p>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>